import React from "react";
import { offersTranslation } from "data/services/translationServices";
import ServiceSection from "./ServiceSection";

const ListOfServices = (props) => {
    return (
        <ServiceSection
            title={offersTranslation.mainTitle[props.language.language]}
        >
            <ul className="services-list">
                {offersTranslation.offers.map((item, idx) => {
                    return (
                        <li key={`service-offers-item-${idx}`} className={(idx+1) % 2 === 0 ? "animate-fade-left" : "animate-fade-right"}>
                            <h4>
                                {item.text[props.language.language]}
                            </h4>
                            <div className="icon-wrapper">
                                <ion-icon name={item.icon}></ion-icon>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </ServiceSection>
    );
};

export default ListOfServices;
